<div class="chat-layout-container">
  
  <app-back-header 
    [headerText]="'Torna alla dashboard'" 
    (backAction)="backToDashboard()" 
    class="sticky-top flex-shrink-0">
  </app-back-header>

  <!-- <h3 class="ms-2 mt-2 flex-shrink-0">Commercialista</h3> -->

  <mat-card class="mt-2 mb-2 py-3 px-2 izy-sharp-bl text-button-card custom-card-border flex-shrink-0">
    <div class="card-content">
      <div class="card-text m-0">
        <h5 class="card-text m-0" >Questa è la tua chat</h5>
        <p class="card-text text-muted text-small m-0 hidden-mobile">Il tuo Commercialista: {{organization_data?.commercialista_name}}</p>
        <p class="card-text text-muted text-small m-0 visible-mobile">Commercialista: {{organization_data?.commercialista_name}}</p>
      </div>
      <button
        mat-raised-button
        class="primary-button custom-button-border hidden-mobile flex-shrink-0"
        matTooltip="Fissa una call con il tuo Commercialista"
        (click)="bookACall()"
        >
        <mat-icon>call</mat-icon> Fissa una call
      </button>
      <button
        mat-raised-button
        class="primary-button custom-button-border visible-mobile flex-shrink-0"
        matTooltip="Fissa una call con il tuo Commercialista"
        (click)="bookACall()">
        <mat-icon>call</mat-icon> Call
      </button>
    </div>
  </mat-card>

  <div class="chat-body-row row m-0 flex-grow-1 overflow-hidden pb-3 flex-column flex-md-row flex-nowrap">

    <!-- Su desktop la colonna si stira per tutta l'altezza della riga (nessun
         tappo in vh): l'elenco scorre al suo interno e la card chiude in fondo
         allineata alla barra di scrittura. Su mobile resta alta quanto serve. -->
    <div class="conversation-column col-12 col-md-3 d-flex flex-column px-0 pe-md-2 mb-2 mb-md-0 flex-shrink-0">
      <mat-card class="conversation-outline-card izy-sharp-bl custom-card-border flex-grow-1 p-3 d-flex flex-column overflow-hidden">

        <button mat-raised-button class="primary-button custom-button-border mb-3 ms-2 me-2 hidden-mobile flex-shrink-0" (click)="createNewConversation()">
          <mat-icon>chat_add_on</mat-icon>
          Nuova conversazione
        </button>
        <!-- mobile version  -->
         <button mat-raised-button class="primary-button custom-button-border mb-3 visible-mobile flex-shrink-0" (click)="createNewConversation()">
          <mat-icon>chat_add_on</mat-icon>
          Nuova conversazione
        </button>

        <!-- new conversation dialog  -->
        <ng-template #newConversationDialog let-dialogRef="dialogRef">
          <h2 mat-dialog-title class="m-0 pt-3 ps-3">Nuova Conversazione</h2>
          
          <mat-dialog-content class="pt-3">
            
            <p class="mb-3">Di cosa hai bisogno?</p>
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-select
                class="izy-select-trigger"
                panelClass="izy-select-panel izy-select-panel--form"
                [(ngModel)]="newDialogTopic">
                <mat-option *ngFor="let topic of conversationTopics" [value]="topic.value">
                  {{ topic.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <p class="mt-4 mb-3">Inserisci l'oggetto della nuova conversazione:</p>
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Oggetto</mat-label>
                <input matInput 
                  maxlength="100"
                  [(ngModel)]="newDialogSubject" 
                  (keyup.enter)="dialogRef.close({ subject: newDialogSubject, topic: newDialogTopic })" 
                  autofocus>
            </mat-form-field>
            
          </mat-dialog-content>

          <mat-dialog-actions align="end" class="pb-3 pe-3">
            <button mat-button (click)="dialogRef.close()">Annulla</button>
            
            <button mat-raised-button class="primary-button custom-button-border"
                    (click)="dialogRef.close({ subject: newDialogSubject, topic: newDialogTopic })"
                    [disabled]="!newDialogSubject?.trim() || !newDialogTopic">
              <mat-icon>chat_add_on</mat-icon>
              Crea
            </button>
          </mat-dialog-actions>
        </ng-template>
        
        <div class="conversation-list flex-grow-1 overflow-y-auto pe-2 hidden-mobile">
          <div *ngIf="!loading && conversations.length > 0">
            <div *ngFor="let conversation of conversations"
                class="conversation-wrapper mb-2"
                (click)="selectConversation(conversation)"
                [ngClass]="{'active-conversation': selectedConversation?.id === conversation.id}">

              <div>
                <div class="message-content pt-2 ms-2"
                    [class.fw-bold]="(selectedConversation?.id === conversation.id) || (unreadCounts[conversation.id] > 0)">

                  {{ truncateText(conversation.subject, 60) }}

                  <span *ngIf="unreadCounts[conversation.id] > 0" class="unread-badge">
                    {{ unreadCounts[conversation.id] }}
                  </span>

                </div>
                <p class="text-muted text-small ms-2 mb-0">
                  {{ getTopicLabel(conversation.topic) }}
                </p>
                <div class="message-footer me-2 pb-2">
                  {{ formatDate(conversation.date_start) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- mobile version  -->
        <mat-form-field appearance="outline" class="mb-0 w-100 flex-shrink-0 visible-mobile" subscriptSizing="dynamic">
          <!-- <mat-label>Seleziona una chat</mat-label> -->
          <mat-select
            class="izy-select-trigger"
            panelClass="izy-select-panel izy-select-panel--form"
            [value]="selectedConversation"
            (selectionChange)="selectConversation($event.value)">

            <mat-select-trigger>
              <span class="fw-bold">
                {{ selectedConversation?.subject }}
                <span *ngIf="selectedConversation && unreadCounts[selectedConversation.id] > 0" class="unread-badge">
                  {{ unreadCounts[selectedConversation.id] }}
                </span>
              </span>
            </mat-select-trigger>

            <mat-option *ngFor="let conversation of conversations" [value]="conversation">

              <span [class.fw-bold]="unreadCounts[conversation.id] > 0">
                {{ truncateText(conversation.subject, 50) }}
                <span *ngIf="unreadCounts[conversation.id] > 0" class="unread-badge">
                  {{ unreadCounts[conversation.id] }}
                </span>
              </span>

              <span class="text-muted text-small ms-2">({{ formatDate(conversation.date_start) }})</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

      </mat-card>
    </div>

    <div class="chat-column col-12 col-md-9 d-flex flex-column h-100 px-0 ps-md-2 flex-grow-1">

      <mat-card *ngIf="!selectedConversation && !loading" class="chat-outline-card custom-card-border flex-grow-1 d-flex flex-column align-items-center justify-content-center mb-2">
        <mat-icon style="transform: scale(2); color: var(--primary-color, #085961); opacity: 0.35;">forum</mat-icon>
        <h3 class="mt-4 text-muted">Seleziona una conversazione</h3>
      </mat-card>

      <ng-container *ngIf="selectedConversation">
        <mat-card class="chat-outline-card custom-card-border flex-grow-1 d-flex flex-column overflow-hidden mb-2" style="min-height: 0;">
          
          <div class="chat-container flex-grow-1 overflow-y-auto" style="min-height: 0;" #scrollContainer>
          
            <div *ngIf="loading" class="text-center p-3 loading-container">
              <mat-spinner diameter="40"></mat-spinner>
            </div>

            <div *ngIf="!loading && tickets.length === 0" class="empty-container">
              <mat-icon>chat_dashed</mat-icon>
              <h3>Nessun messaggio trovato</h3>
              <p>Inizia subito la conversazione!</p>
            </div>  
            
            <!-- messages + automatic notification while waiting for an answer -->
            <div *ngIf="!loading && tickets.length > 0" class="p-3">
              <div *ngFor="let ticket of tickets"
                  [ngClass]="{'message-out': ticket.type === 'OUT', 'message-in': ticket.type === 'IN'}"
                  [class.fw-bold]="ticket.is_read === false"
                  class="message-wrapper">
                <div class="message-bubble">
                  <div class="message-content">{{ ticket.message }}</div>
                  <div class="message-footer">
                    {{ ticket.hour | slice:0:5 }} - {{ formatDate(ticket.date) }}
                  </div>
                </div>
              </div>
              <!-- Shown until someone answers, regardless of how many messages
                   the customer has sent. -->
              <div *ngIf="showAssistanceNotice" class="empty-container">
                <mat-icon>mark_chat_read</mat-icon>
                <h3>Richiesta ricevuta!</h3>
                <p>{{ availabilityMessage }}</p>
              </div>
            </div>

          </div>
        </mat-card>
      </ng-container>
    
      <!-- Availability banner: the customer knows the offices are closed
           BEFORE writing, not only after sending. -->
      <div *ngIf="availability"
           class="availability-banner flex-shrink-0"
           [class.availability-closed]="!isAssistanceOpen">
        <mat-icon>{{ isAssistanceOpen ? 'schedule' : 'event_busy' }}</mat-icon>
        <span>{{ availabilityMessage }}</span>
      </div>

      <mat-card class="chat-input-card flex-shrink-0 ms-0 me-0">
        <div class="input-container ps-3 pe-2 py-2">
            
          <mat-form-field appearance="outline" class="flex-grow-1 custom-height-field" subscriptSizing="dynamic">
            <textarea matInput 
                      #autosize="cdkTextareaAutosize" 
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="1"
                      cdkAutosizeMaxRows="5"
                      [(ngModel)]="newMessage" 
                      (keydown.enter)="handleEnter($event)"
                      placeholder="Digita qui..."></textarea>
          </mat-form-field>

          <button 
            mat-icon-button 
            class="send-button ms-2" 
            matTooltip="Invia messaggio"
            (click)="sendMessage()" 
            [disabled]="!newMessage?.trim()">
            <mat-icon>send</mat-icon>
          </button>
          
        </div>
      </mat-card>

      <!-- new message check dialog  -->
      <ng-template #confirmSendDialog let-dialogRef="dialogRef">
        <h2 mat-dialog-title class="m-0 pt-3">Attenzione</h2>
        
        <mat-dialog-content class="pt-3">
          <p class="mb-0">Sicuro di voler inviare un nuovo messaggio qui? Non hai ancora ricevuto risposta.</p>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="pb-3 pe-3">
          <button mat-button (click)="dialogRef.close(false)">Annulla</button>
          <button mat-raised-button class="primary-button custom-button-border" (click)="dialogRef.close(true)">
            <mat-icon>send</mat-icon>
            Invia comunque
          </button>
        </mat-dialog-actions>
      </ng-template>

      <!-- message received feedback dialog  -->
      <ng-template #receivedMessageDialog let-dialogRef="dialogRef">
        <div class="download-dialog">
          <h2 mat-dialog-title class="m-0 pt-3">Messaggio ricevuto</h2>

          <div class="success-container">
            <mat-icon class="success-icon mb-3" color="primary">mark_chat_read</mat-icon>
            <p class="success-message">Il tuo messaggio è stato ricevuto dal nostro Team!</p>
          </div>
          
          <mat-dialog-content class="pt-3">
            <!-- <p class="mb-0">Il tuo messaggio è stato ricevuto dal nostro Team!</p> -->
            <p class="mt-2 mb-0">{{ availabilityMessage }}</p>
          </mat-dialog-content>

          <mat-dialog-actions align="end" class="pb-3 pe-3">
            <!-- <button mat-button (click)="dialogRef.close(false)">indietro</button> -->
            <button mat-raised-button class="primary-button custom-button-border" (click)="dialogRef.close(true)">
              <mat-icon>check</mat-icon>
              Ok, grazie!
            </button>
          </mat-dialog-actions>
        </div>
      </ng-template>

    </div>
  </div>

</div>